const GlobalPagination = {
  pageSize: 10,
  page: 1,
  limitOptions: [10, 25, 50, 100],
};

export default GlobalPagination;
